import { z } from "zod";
import { nanoidSchema } from "../../utility/index.js";
import { nanoid } from "../../utility/index.js";
import { projectIconSchema } from "../icon.js";
var SidebarType = /* @__PURE__ */ ((SidebarType2) => {
  SidebarType2["Page"] = "Page";
  SidebarType2["Folder"] = "Folder";
  SidebarType2["Link"] = "Link";
  return SidebarType2;
})(SidebarType || {});
const baseSidebarItemSchema = z.object({
  uid: nanoidSchema,
  title: z.string().trim().min(1),
  type: z.enum(SidebarType),
  link: z.string().optional(),
  icon: projectIconSchema.optional(),
  children: z.string().array().optional(),
  description: z.string().optional(),
  show: z.boolean()
});
const linkSchema = baseSidebarItemSchema.extend({
  title: z.preprocess(
    (arg) => arg?.trim() || "Link",
    z.string().trim().min(1)
  ),
  link: z.string(),
  type: z.literal("Link" /* Link */)
});
const pageSchema = baseSidebarItemSchema.extend({
  title: z.preprocess(
    (arg) => arg?.trim() || "Page",
    z.string().trim().min(1)
  ),
  sidebarTitle: z.string().optional(),
  description: z.string(),
  children: z.string().array().default([]),
  type: z.literal("Page" /* Page */),
  defaultOpen: z.boolean().optional(),
  yjsReference: z.string(),
  backgroundImage: z.string().optional(),
  icon: projectIconSchema.optional(),
  /**
   * Automatically set during sync builds when we map markdown and mdx files to pages
   *
   * Used by the Vue builds to determine how to render a given page item.
   */
  isMdx: z.boolean().default(false),
  /**
   * Automatically set during sync builds when we map HTML files to pages.
   */
  isHtml: z.boolean().default(false)
});
const defaultPage = () => ({
  uid: nanoid(),
  title: "Getting Started",
  type: "Page" /* Page */,
  description: "Start writing your API Documentation with our platform",
  children: [],
  show: true,
  yjsReference: nanoid(),
  isMdx: false,
  isHtml: false
});
const folderSchema = baseSidebarItemSchema.extend({
  title: z.preprocess(
    (arg) => arg?.trim() || "Folder",
    z.string().trim().min(1)
  ),
  children: z.string().array().default([]),
  type: z.literal("Folder" /* Folder */),
  defaultOpen: z.boolean().optional()
});
const sidebarItemSchema = z.union([
  linkSchema,
  pageSchema,
  folderSchema
]);
const sidebarSchema = z.object({
  /** Complete record of ALL sidebar items */
  items: z.record(z.string(), sidebarItemSchema),
  /** Ordered list of the direct children */
  children: z.string().array()
}).transform((val) => {
  const hasPage = Object.values(val.items).some(
    (item) => item.type === "Page" /* Page */
  );
  if (!hasPage) {
    const firstPage = defaultPage();
    val.items[firstPage.uid] = firstPage;
    val.children.push(firstPage.uid);
  }
  return val;
});
export {
  SidebarType,
  defaultPage,
  sidebarItemSchema,
  sidebarSchema
};
//# sourceMappingURL=sidebar.js.map
